'use strict'

# https://developers.google.com/identity/sign-in/web/reference
Google =

  init: (signinFlyout) ->
    return if not ($googleBtn = $('#ls-btn-google')).length
    @signinFlyout = signinFlyout
    $googleBtn.on 'click', => @signIn()

  signIn: ->
    $('#ls-signin-error').text('').hide()
    authUrl = 'https://accounts.google.com/o/oauth2/auth'
    bCookie = Cookie.get('b') || ''
    returnTo = window.location.href
    params =
      rememberMe: if $('#ls-remember-me').prop('checked') then 1 else 0
      access_type: 'offline'
      response_type: 'code'
      client_id: Groupon.LS.data.googleClientId,
      redirect_uri: "#{location.protocol}//#{location.host}/google_auth_callback"
      scope: 'profile email'
      state: "#{bCookie}@#{returnTo}@metric:layout_login" # add metric

    urlParams = _.map(params, (val, key) ->
      return "#{key}=#{encodeURIComponent(val)}"
    ).join('&')
    Cookie.set('X-Google-Iframe', true) # user sessions hack, to stay in the same page
    @openInPopup("#{authUrl}?#{urlParams}", 500, 600)

  openInPopup: (url, w, h) ->
    dualScreenLeft = if window.screenLeft then window.screenLeft else screen.left
    dualScreenTop = if window.screenTop then window.screenTop else screen.top
    width = if window.innerWidth then window.innerWidth else ( if document.documentElement.clientWidth then  document.documentElement.clientWidth else screen.width)
    height = if window.innerHeight then window.innerHeight else ( if document.documentElement.clientHeight then document.documentElement.clientHeight else screen.height)
    left = ((width / 2) - (w / 2)) + dualScreenLeft
    top = ((height / 2) - (h / 2)) + dualScreenTop
    window.open(url, 'google_login_form', "width=#{w}, height=#{h}, top=#{top}, left=#{left}")

module.exports = Google



// WEBPACK FOOTER //
// ./modules/gig_body/header/signin_flyout/frontend/google.coffee